const filterArrayByField = (array, field, value, value2 = "") =>
  array?.filter((item) => item[field] === value || item[field] === value2);

export default filterArrayByField;
